module.exports = "images/france-tv.7b24e983.png";